import { degToRad } from './'
import { Vector3, Box3 } from 'three'

export function visibleViewport( camera, target = new Vector3(0), position ) {
  position = position !== void 0 ? position : camera.position
  const vFOV = degToRad(camera.fov)
  const dist = position.distanceTo(target)
  const height = 2 * Math.tan( vFOV / 2 ) * dist
  const width = height * camera.aspect

  const halfWidth = width * .5
  const halfHeight = height * .5

  return {
    height: height,
    width: width,
    box: new Box3(new Vector3( target.x - halfWidth, target.y - halfHeight, -Infinity ), new Vector3( target.x + halfWidth, target.y + halfHeight, Infinity ))
  }
}